import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "growthGoal",
    initialState: 5,
    reducers: {
        set: (state, action) => action.payload,
    },
});
